<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
        <div class="text-bodt-2 font-weight-black my-4">
          {{ componentData.sub }}
        </div>
      </v-col>
      <v-col>
        <v-form ref="form" v-model="componentData.formSetting.valid" lazy-validation @submit.prevent>
          <v-text-field
            outlined
            hide-details="auto"
            v-model="signUpDate.email"
            :label="componentData.formSetting.input1.label"
            :placeholder="componentData.formSetting.input1.placeholder"
            :rules="componentData.formSetting.input1.rules"
            :error-messages="componentData.formSetting.input1.errorMsg"
            @focus="ResetErrorValidation"
            @keyup.enter="Mail_SendConfirmMail()"
          ></v-text-field>
          <div class="py-2"></div>
        </v-form>

        <div class="py-4"></div>
        <v-btn block large color="primary" :loading="componentData.loading" @click="Mail_SendConfirmMail()">
          <span class="mx-2 text-capitalize">{{ componentData.signup }}</span>
        </v-btn>

        <v-row class="d-flex">
          <v-col cols="6">
            <v-divider class="my-10"></v-divider>
          </v-col>
          <div class="my-11 body-2 text--disabled">
            {{ componentData.or }}
          </div>
          <v-col>
            <v-divider class="my-10"></v-divider>
          </v-col>
        </v-row>

        <v-btn block large outlined class="btn-gray-border" :loading="componentData.googleLoading" @click="GoogleSignupWithRefAPI()">
          <v-img contain max-height="22.8" max-width="24" :src="componentData.googleLogo"></v-img>
          <span class="mx-2 text-capitalize">{{ componentData.googleLogin }}</span>
        </v-btn>

        <!-- <div class="py-4"></div>
        <v-btn
          block
          large
          color="primary"
          :loading="componentData.loading"
          @click="Mail_SendConfirmMail()"
        >
          <span class="mx-2 text-capitalize">{{ componentData.signup }}</span>
        </v-btn> -->
        <div class="py-4"></div>
        <div class="d-flex justify-center align-center mt-4">
          <div class="text-body-1 mr-2">{{ componentData.haveAcc }}</div>
          <v-btn color="primary" class="px-2 text-body-2" height="30" outlined @click="GoSignIn()">
            {{ componentData.memberSignin }}
          </v-btn>
        </div>
        <div class="py-4"></div>
        <div class="text-body-2" align="left">
          {{ componentData.description.text1 }}
          <v-btn text color="deep-purple accent-3" class="pa-0 pb-1 text-decoration-underline" style="height: auto" plain @click="GoPage('Terms')">
            {{ componentData.description.terms }}
          </v-btn>
          、
          <v-btn text color="deep-purple accent-3" class="pa-0 pb-1 text-decoration-underline" style="height: auto" plain @click="GoPage('PrivacyPolicy')">
            {{ componentData.description.text4 }}
          </v-btn>
          {{ componentData.description.text3 }}
          <v-btn text color="deep-purple accent-3" class="pa-0 pb-1 text-decoration-underline" style="height: auto" plain @click="GoPage('Disclaimer')">
            {{ componentData.description.text2 }}
          </v-btn>
          {{ componentData.description.text5 }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Mail_SendConfirmMail, Google_Login } from "@/apis/api";
import { startGoogleLogin } from "@/utils/googlePopup";
import { withGoogleAccountChooser } from "@/utils/googleAuthUrl";
import { canUseAppAuth, openGoogleAuth } from "@/utils/nativeApp";

export default {
  name: "SignUp",
  data() {
    return {
      componentData: {
        title: "免費會員註冊",
        sub: "註冊會員，享受小芋頭各式服務",
        formSetting: {
          valid: true,
          input1: {
            label: "帳號(電子信箱)",
            placeholder: "email",
            rules: [(v) => !!v || "此欄位必填", (v) => /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(v) || "格式錯誤，請重新輸入"],
            errorMsg: "",
          },
        },
        forgotPwd: "忘記密碼?",
        or: "或",
        hint: "請輸入最少6個字元，混合英數字之密碼",
        googleLogo: require("@/assets/image/components/Google Icon.svg"),
        googleLogin: "以Google帳號註冊",
        signup: "下一步",
        haveAcc: "已經有小芋頭帳號?",
        memberSignin: "會員登入",
        loading: false,
        googleLoading: false,
        description: {
          text1: "透過Google, 或電子信箱註冊小芋頭會員，即表示您已閱讀並同意",
          terms: "會員服務條款",
          text2: "免責聲明",
          text3: "與",
          text4: "隱私權政策",
          text5: "。",
        },
      },
      signUpDate: {
        email: null,
        password: null,
      },
    };
  },
  // 內嵌在社群、AI 站對話框時（views/EmbedLogin.vue）：收信回來、Google 整頁跳轉都要回到外層網站
  inject: { embedHost: { default: null } },
  props: {
    // page：登入頁；dialog：登入對話框（components/Common/LoginDialog.vue）
    mode: { type: String, default: "page" },
    // 對話框：註冊、登入完要前往的站內路徑
    after: { type: String, default: null },
  },
  computed: {
    isDialog() {
      return this.mode === "dialog";
    },
  },
  beforeDestroy() {
    if (this.googleFlow) this.googleFlow.cancel();
  },
  mounted() {
    // 對話框：推薦碼開對話框時已經決定好（utils/loginDialog.js），社群邀請只走登入頁，這裡不動
    if (this.isDialog) return;

    if (this.$route.query.ivtem) {
      localStorage.setItem("inviterQuery", `cmid=${this.$route.query.cmid}&ivtem=${this.$route.query.ivtem}`);
      localStorage.setItem("inviterEmail", this.$route.query.ivtem);
    } else {
      localStorage.removeItem("inviterQuery");
      localStorage.removeItem("inviterEmail");
    }

    // AI平台前端過來得分享會員emailCode
    if (this.$route.query.refc) {
      const raw = this.$route.query.refc;
      const refc = Array.isArray(raw) ? raw[0] : raw;
      localStorage.setItem("referral_code", refc);
    } else {
      localStorage.removeItem("referral_code");
    }
  },
  methods: {
    GoPage(router) {
      let routeData = this.$router.resolve({ name: router });
      window.open(routeData.href, "_blank");
    },
    // 清除表單驗證
    ResetErrorValidation() {
      // this.$refs.form.resetValidation();
      this.componentData.formSetting.input1.errorMsg = "";
    },
    // 寄送驗證信
    Mail_SendConfirmMail() {
      // 欄位驗證
      this.$refs.form.validate();
      // 驗證不過直接回傳
      if (!this.$refs.form.validate()) return false;

      this.componentData.loading = true;

      let data = {
        email: this.signUpDate.email,
        communityID: this.$route.query.cmid,
        InviterEmail: this.$route.query.ivtem,
        // 對話框：網址上不一定有 refc（逛到別頁才按註冊），用開對話框時決定好的推薦碼
        ReferralCode: this.$route.query.refc || (this.isDialog ? localStorage.getItem("referral_code") || undefined : undefined),
      };
      // api;
      Mail_SendConfirmMail(data)
        .then((res) => {
          console.log(res.data.message);
          this.componentData.loading = false;
          localStorage.setItem("signupEmail", this.signUpDate.email);
          // 對話框：收信設定密碼、登入完回到現在這一頁
          if (this.isDialog) {
            const back = this.embedHost ? this.embedHost.returnUrl : this.after || window.location.href;
            if (back) localStorage.setItem("redirectAfterLogin", back);
          }
          // 成功跳轉頁
          this.GoVerifyEmail();
        })
        .catch((err) => {
          this.componentData.loading = false;
          this.componentData.formSetting.input1.errorMsg = err.response.data.message;
        });
    },
    // Google登入
    GoogleSignIn() {
      this.componentData.googleLoading = true;
      localStorage.removeItem("_token");
      // App 裡改用系統瀏覽器分頁開 Google（Google 不允許在 App 內嵌的網頁視窗登入）
      Google_Login(canUseAppAuth())
        .then((res) => openGoogleAuth(withGoogleAccountChooser(res.data)))
        .then(() => {
          this.componentData.googleLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.componentData.googleLoading = false;
        });
    },
    // Google 登入註冊帶推薦人。對話框（電腦版）開小視窗、登入完留在原頁面；其他情況整頁跳轉（見 utils/googlePopup.js）
    GoogleSignupWithRefAPI() {
      const referred = localStorage.getItem("referral_code");
      const inviterEmail = localStorage.getItem("inviterEmail");

      // 記錄「本次帶推薦碼」意圖，讓 Google 轉跳回來後仍能做註冊後結果確認
      if (referred || inviterEmail) sessionStorage.setItem("pending_referral_check", "1");
      this.componentData.googleLoading = true;
      const flow = startGoogleLogin({
        refc: referred ?? inviterEmail,
        popup: this.isDialog,
        returnUrl: this.embedHost ? this.embedHost.returnUrl : this.isDialog ? this.after || window.location.href : null,
        navigate: this.embedHost ? this.embedHost.navigateTop : null,
        onIdle: () => {
          this.componentData.googleLoading = false;
        },
      });
      this.googleFlow = flow;
      flow.promise
        .then(async (result) => {
          if (result === "signed-in") {
            await this.$store.dispatch("GetEmailEncrypt");
            this.$emit("signed-in");
          }
          this.componentData.googleLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.componentData.googleLoading = false;
        });
    },
    // 轉登入頁面
    GoSignIn() {
      this.$emit("switch", "SignIn");
    },
    // 轉重設密碼頁面
    GoResetPwd() {
      this.$emit("switch", "ResetPwd");
    },
    GoVerifyEmail() {
      this.$emit("switch", "VerifyEmail");
    },
  },
};
</script>
